/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type PROJECT_STATUS = "DONE" | "HALTED" | "OPPORTUNITY" | "PLANNING" | "RUNNING" | "%future added value";
export type STATUS_CATEGORY = "DONE" | "INPROGRESS" | "TODO" | "%future added value";
export type TimeRegistrationTargetSuggestionsFetch_QueryVariables = {
    timePeriod?: string | null | undefined;
    currentViewingDate?: string | null | undefined;
};
export type TimeRegistrationTargetSuggestionsFetch_QueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly component: string | null;
        readonly timeRegistrationTargetSuggestions: {
            readonly modelVersion: string | null;
            readonly sortedSuggestions: ReadonlyArray<{
                readonly id: string;
                readonly rank: number | null;
                readonly task: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly progress: number | null;
                    readonly companyTaskId: number | null;
                    readonly highPriority: boolean | null;
                    readonly approved: boolean | null;
                    readonly favoured: boolean | null;
                    readonly fullAccessToProject: boolean | null;
                    readonly latestUiUpdateAt: string | null;
                    readonly startDay: number | null;
                    readonly startMonth: number | null;
                    readonly startYear: number | null;
                    readonly deadlineYear: number | null;
                    readonly deadlineMonth: number | null;
                    readonly deadlineDay: number | null;
                    readonly timeLeft: number | null;
                    readonly estimateForecastMinutes: number | null;
                    readonly totalMinutesRegistered: number | null;
                    readonly parentTaskId: string | null;
                    readonly billable: boolean | null;
                    readonly assignedPersons: ReadonlyArray<{
                        readonly id: string;
                    } | null> | null;
                    readonly statusColumnV2: {
                        readonly category: STATUS_CATEGORY | null;
                    } | null;
                    readonly project: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly status: PROJECT_STATUS | null;
                        readonly companyProjectId: number | null;
                        readonly projectColor: string | null;
                        readonly estimationUnit: string | null;
                        readonly fullAccessToProject: boolean | null;
                        readonly manualProgressOnProjectEnabled: boolean | null;
                        readonly manualProgressOnPhasesEnabled: boolean | null;
                        readonly manualProgressOnTasksEnabled: boolean | null;
                        readonly client: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                        readonly harvestProject: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                        readonly unit4Project: {
                            readonly id: string;
                            readonly name: string | null;
                        } | null;
                    } | null;
                    readonly phase: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
                readonly project: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly status: PROJECT_STATUS | null;
                    readonly companyProjectId: number | null;
                    readonly projectColor: string | null;
                    readonly estimationUnit: string | null;
                    readonly fullAccessToProject: boolean | null;
                    readonly client: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                    readonly harvestProject: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                    readonly unit4Project: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
                readonly idleTime: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly isInternalTime: boolean | null;
                    readonly favoured: boolean | null;
                    readonly disabled: boolean | null;
                } | null;
                readonly total: number | null;
            } | null> | null;
        } | null;
        readonly oldTimeRegistrationTargetSuggestions: ReadonlyArray<{
            readonly task: {
                readonly id: string;
                readonly name: string | null;
                readonly progress: number | null;
                readonly companyTaskId: number | null;
                readonly highPriority: boolean | null;
                readonly approved: boolean | null;
                readonly favoured: boolean | null;
                readonly fullAccessToProject: boolean | null;
                readonly latestUiUpdateAt: string | null;
                readonly startDay: number | null;
                readonly startMonth: number | null;
                readonly startYear: number | null;
                readonly deadlineYear: number | null;
                readonly deadlineMonth: number | null;
                readonly deadlineDay: number | null;
                readonly timeLeft: number | null;
                readonly estimateForecastMinutes: number | null;
                readonly totalMinutesRegistered: number | null;
                readonly parentTaskId: string | null;
                readonly billable: boolean | null;
                readonly assignedPersons: ReadonlyArray<{
                    readonly id: string;
                } | null> | null;
                readonly statusColumnV2: {
                    readonly category: STATUS_CATEGORY | null;
                } | null;
                readonly project: {
                    readonly id: string;
                    readonly name: string | null;
                    readonly status: PROJECT_STATUS | null;
                    readonly companyProjectId: number | null;
                    readonly projectColor: string | null;
                    readonly estimationUnit: string | null;
                    readonly fullAccessToProject: boolean | null;
                    readonly manualProgressOnProjectEnabled: boolean | null;
                    readonly manualProgressOnPhasesEnabled: boolean | null;
                    readonly manualProgressOnTasksEnabled: boolean | null;
                    readonly client: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                    readonly harvestProject: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                    readonly unit4Project: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null;
                readonly phase: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null;
            readonly idleTime: {
                readonly id: string;
                readonly name: string | null;
                readonly isInternalTime: boolean | null;
                readonly favoured: boolean | null;
                readonly disabled: boolean | null;
            } | null;
            readonly total: number | null;
        } | null> | null;
    } | null;
};
export type TimeRegistrationTargetSuggestionsFetch_Query = {
    readonly response: TimeRegistrationTargetSuggestionsFetch_QueryResponse;
    readonly variables: TimeRegistrationTargetSuggestionsFetch_QueryVariables;
};



/*
query TimeRegistrationTargetSuggestionsFetch_Query(
  $timePeriod: String
  $currentViewingDate: String
) {
  viewer {
    id
    component(name: "time_registration_target_suggestions")
    timeRegistrationTargetSuggestions(timePeriod: $timePeriod, currentViewingDate: $currentViewingDate) {
      modelVersion
      sortedSuggestions {
        id
        rank
        task {
          id
          name
          progress
          companyTaskId
          highPriority
          approved
          favoured
          fullAccessToProject
          latestUiUpdateAt
          startDay
          startMonth
          startYear
          deadlineYear
          deadlineMonth
          deadlineDay
          timeLeft
          estimateForecastMinutes
          totalMinutesRegistered
          parentTaskId
          billable
          assignedPersons {
            id
          }
          statusColumnV2 {
            category
            id
          }
          project {
            id
            name
            status
            companyProjectId
            projectColor
            estimationUnit
            fullAccessToProject
            manualProgressOnProjectEnabled
            manualProgressOnPhasesEnabled
            manualProgressOnTasksEnabled
            client {
              id
              name
            }
            harvestProject {
              id
              name
            }
            unit4Project {
              id
              name
            }
          }
          phase {
            id
            name
          }
        }
        project {
          id
          name
          status
          companyProjectId
          projectColor
          estimationUnit
          fullAccessToProject
          client {
            id
            name
          }
          harvestProject {
            id
            name
          }
          unit4Project {
            id
            name
          }
        }
        idleTime {
          id
          name
          isInternalTime
          favoured
          disabled
        }
        total
      }
      id
    }
    oldTimeRegistrationTargetSuggestions(timePeriod: $timePeriod, currentViewingDate: $currentViewingDate) {
      task {
        id
        name
        progress
        companyTaskId
        highPriority
        approved
        favoured
        fullAccessToProject
        latestUiUpdateAt
        startDay
        startMonth
        startYear
        deadlineYear
        deadlineMonth
        deadlineDay
        timeLeft
        estimateForecastMinutes
        totalMinutesRegistered
        parentTaskId
        billable
        assignedPersons {
          id
        }
        statusColumnV2 {
          category
          id
        }
        project {
          id
          name
          status
          companyProjectId
          projectColor
          estimationUnit
          fullAccessToProject
          manualProgressOnProjectEnabled
          manualProgressOnPhasesEnabled
          manualProgressOnTasksEnabled
          client {
            id
            name
          }
          harvestProject {
            id
            name
          }
          unit4Project {
            id
            name
          }
        }
        phase {
          id
          name
        }
      }
      idleTime {
        id
        name
        isInternalTime
        favoured
        disabled
      }
      total
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timePeriod",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentViewingDate",
    "type": "String"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "time_registration_target_suggestions"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"time_registration_target_suggestions\")"
},
v3 = [
  {
    "kind": "Variable",
    "name": "currentViewingDate",
    "variableName": "currentViewingDate"
  },
  {
    "kind": "Variable",
    "name": "timePeriod",
    "variableName": "timePeriod"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelVersion",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rank",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "highPriority",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approved",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestUiUpdateAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeLeft",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimateForecastMinutes",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalMinutesRegistered",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentTaskId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "assignedPersons",
  "plural": true,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v31 = [
  (v1/*: any*/),
  (v6/*: any*/)
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v6/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnProjectEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnPhasesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manualProgressOnTasksEnabled",
      "storageKey": null
    },
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "PhaseType",
  "kind": "LinkedField",
  "name": "phase",
  "plural": false,
  "selections": (v31/*: any*/),
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "statusColumnV2",
      "plural": false,
      "selections": [
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectType",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v6/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v12/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "IdleTime",
  "kind": "LinkedField",
  "name": "idleTime",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInternalTime",
      "storageKey": null
    },
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disabled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "statusColumnV2",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    (v35/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeRegistrationTargetSuggestionsFetch_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TimeRegistrationTargetSuggestions",
            "kind": "LinkedField",
            "name": "timeRegistrationTargetSuggestions",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegistrationTargetSuggestion",
                "kind": "LinkedField",
                "name": "sortedSuggestions",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v37/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SuggestedTaskOld",
            "kind": "LinkedField",
            "name": "oldTimeRegistrationTargetSuggestions",
            "plural": true,
            "selections": [
              (v37/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimeRegistrationTargetSuggestionsFetch_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "TimeRegistrationTargetSuggestions",
            "kind": "LinkedField",
            "name": "timeRegistrationTargetSuggestions",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeRegistrationTargetSuggestion",
                "kind": "LinkedField",
                "name": "sortedSuggestions",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v5/*: any*/),
                  (v41/*: any*/),
                  (v38/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SuggestedTaskOld",
            "kind": "LinkedField",
            "name": "oldTimeRegistrationTargetSuggestions",
            "plural": true,
            "selections": [
              (v41/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TimeRegistrationTargetSuggestionsFetch_Query",
    "operationKind": "query",
    "text": "query TimeRegistrationTargetSuggestionsFetch_Query(\n  $timePeriod: String\n  $currentViewingDate: String\n) {\n  viewer {\n    id\n    component(name: \"time_registration_target_suggestions\")\n    timeRegistrationTargetSuggestions(timePeriod: $timePeriod, currentViewingDate: $currentViewingDate) {\n      modelVersion\n      sortedSuggestions {\n        id\n        rank\n        task {\n          id\n          name\n          progress\n          companyTaskId\n          highPriority\n          approved\n          favoured\n          fullAccessToProject\n          latestUiUpdateAt\n          startDay\n          startMonth\n          startYear\n          deadlineYear\n          deadlineMonth\n          deadlineDay\n          timeLeft\n          estimateForecastMinutes\n          totalMinutesRegistered\n          parentTaskId\n          billable\n          assignedPersons {\n            id\n          }\n          statusColumnV2 {\n            category\n            id\n          }\n          project {\n            id\n            name\n            status\n            companyProjectId\n            projectColor\n            estimationUnit\n            fullAccessToProject\n            manualProgressOnProjectEnabled\n            manualProgressOnPhasesEnabled\n            manualProgressOnTasksEnabled\n            client {\n              id\n              name\n            }\n            harvestProject {\n              id\n              name\n            }\n            unit4Project {\n              id\n              name\n            }\n          }\n          phase {\n            id\n            name\n          }\n        }\n        project {\n          id\n          name\n          status\n          companyProjectId\n          projectColor\n          estimationUnit\n          fullAccessToProject\n          client {\n            id\n            name\n          }\n          harvestProject {\n            id\n            name\n          }\n          unit4Project {\n            id\n            name\n          }\n        }\n        idleTime {\n          id\n          name\n          isInternalTime\n          favoured\n          disabled\n        }\n        total\n      }\n      id\n    }\n    oldTimeRegistrationTargetSuggestions(timePeriod: $timePeriod, currentViewingDate: $currentViewingDate) {\n      task {\n        id\n        name\n        progress\n        companyTaskId\n        highPriority\n        approved\n        favoured\n        fullAccessToProject\n        latestUiUpdateAt\n        startDay\n        startMonth\n        startYear\n        deadlineYear\n        deadlineMonth\n        deadlineDay\n        timeLeft\n        estimateForecastMinutes\n        totalMinutesRegistered\n        parentTaskId\n        billable\n        assignedPersons {\n          id\n        }\n        statusColumnV2 {\n          category\n          id\n        }\n        project {\n          id\n          name\n          status\n          companyProjectId\n          projectColor\n          estimationUnit\n          fullAccessToProject\n          manualProgressOnProjectEnabled\n          manualProgressOnPhasesEnabled\n          manualProgressOnTasksEnabled\n          client {\n            id\n            name\n          }\n          harvestProject {\n            id\n            name\n          }\n          unit4Project {\n            id\n            name\n          }\n        }\n        phase {\n          id\n          name\n        }\n      }\n      idleTime {\n        id\n        name\n        isInternalTime\n        favoured\n        disabled\n      }\n      total\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ce176cb3503727df0f4f99c69ca595ff';
export default node;
